module.exports = __webpack_public_path__ + "static/media/aboutImg1.e7313fe0.png";